// Testimonials

 const testimonials = [
    {
        quote: "I was impressed by the food — every dish is bursting with flavor! And I could really tell that they use high-quality ingredients. The staff was friendly and attentive, going the extra mile. I'll definitely be back for more!",
        name: "Tamar Mendelson"
    },
    {
        quote: "This place exceeded all expectations! The atmosphere is inviting, and the staff truly goes above and beyond to ensure a fantastic visit. I'll definitely keep returning for more exceptional dining experience.",
        name: "Joe Charlescraft"
    },
    {
        quote: "Shining Yam is a hidden gem! From the moment I walked in, I knew I was in for a treat. The impeccable service and overall attention to detail created a memorable experience. I highly recommend it!",
        name: "Martina Edelweist"
    }
];

let activeIndex = 0;
const nameElement = document.getElementById('name');
const quoteElement = document.getElementById('quote');
const prevButton = document.getElementById('prev-button');
const nextButton = document.getElementById('next-button');

function updateTestimonial(direction) {
    activeIndex = (activeIndex + direction + testimonials.length) % testimonials.length;

    nameElement.textContent = testimonials[activeIndex].name;
    quoteElement.innerHTML = testimonials[activeIndex].quote.split(' ').map(word => `<span class="word">${word}</span>`).join(' ');

    animateWords();
}

function animateWords() {
    const words = quoteElement.querySelectorAll('.word');
    words.forEach((word, index) => {
        word.style.opacity = '0';
        word.style.transform = 'translateY(10px)';
        word.style.filter = 'blur(10px)';
        setTimeout(() => {
            word.style.transition = 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out, filter 0.2s ease-in-out';
            word.style.opacity = '1';
            word.style.transform = 'translateY(0)';
            word.style.filter = 'blur(0)';
        }, index * 20);
    });
}

function handleNext() {
    updateTestimonial(1);
}

function handlePrev() {
    updateTestimonial(-1);
}

prevButton.addEventListener('click', handlePrev);
nextButton.addEventListener('click', handleNext);

// Initial setup
updateTestimonial(0);

// Autoplay functionality
const autoplayInterval = setInterval(handleNext, 5000);

// Stop autoplay on user interaction
[prevButton, nextButton].forEach(button => {
    button.addEventListener('click', () => {
        clearInterval(autoplayInterval);
    });
});



//Homepage How it works (tabs) section

$(document).ready(function() { 

	(function ($) { 
		$('.tab ul.tabs').addClass('active').find('> li:eq(0)').addClass('current');
		
		$('.tab ul.tabs li a').click(function (g) { 
			var tab = $(this).closest('.tab'), 
				index = $(this).closest('li').index();
			
			tab.find('ul.tabs > li').removeClass('current');
			$(this).closest('li').addClass('current');
			
			tab.find('.tab_content').find('div.tabs_item').not('div.tabs_item:eq(' + index + ')').slideUp();
			tab.find('.tab_content').find('div.tabs_item:eq(' + index + ')').slideDown();
			
			g.preventDefault();
		} );
	})(jQuery);

});


